import React from "react";
import { GuestUserFormContextProvider } from "../../../provider/home_guest_user/guest_user_form/GuestUserFormContextProvider";
import { Col, Row } from "react-bootstrap";
import {
  GuestUserFormDateField,
  GuestUserFormEmailField,
  GuestUserFormMessageField,
  GuestUserFormNameField,
  GuestUserFormPhoneField,
  GuestUserFormSubjectField,
  GuestUserFormTimeField,
} from "./widget/GuestUserFormTextfields";
import { CountryCodeContextProvider } from "../../../provider/country_code/CountryCodeContextProvider";
import Div from "../../../widget/common/ui/Div";
import GusetUserFormButton from "./widget/GusetUserFormButton";
import Center from "../../../widget/common/ui/Center";

const GuestUserFormContent = (props: { type?: number; isModal?: boolean }) => {
  const isModal: boolean = props.isModal ?? false;

  return (
    <CountryCodeContextProvider>
      <form autoComplete="off">
        {isModal ? (
          <GuestUserFormContextProvider>
            <form autoComplete="off">
              <GuestUserFormContentBody isModal={isModal} />
            </form>
          </GuestUserFormContextProvider>
        ) : (
          <GuestUserFormContentBody isModal={isModal} />
        )}
      </form>
    </CountryCodeContextProvider>
  );
};

export default GuestUserFormContent;

const GuestUserFormContentBody = (props: {
  isModal?: boolean;
}) => {
  const isModal: boolean = props.isModal ?? false;

  return (
    <Div className="mx-auto  px-lg-2">
      <Row>
        <Col xs={12} lg={6}>
          <GuestUserFormNameField />
        </Col>
        <Col xs={12} lg={6}>
          <GuestUserFormEmailField />
        </Col>
        <Col xs={12} lg={6}>
          <GuestUserFormPhoneField />
        </Col>
        {isModal ? (
          <>
            <Col xs={12} lg={6}>
              <GuestUserFormDateField />
            </Col>
            <Col xs={12} lg={6}>
              <GuestUserFormTimeField />
            </Col>
          </>
        ) : (
          <>
            <Col>
              <GuestUserFormDateField />
            </Col>
            <Col>
              <GuestUserFormTimeField />
            </Col>
          </>
        )}

        <Col xs={12} lg={6}>
          <GuestUserFormSubjectField />
        </Col>
        <Col xs={12}>
          <GuestUserFormMessageField />
        </Col>
      </Row>

      {isModal && (
        <Center className="mt-5">
          <GusetUserFormButton />
        </Center>
      )}
    </Div>
  );
};
